import { render, staticRenderFns } from "./AgentMessageBubble.vue?vue&type=template&id=0bdabf58&"
import script from "./AgentMessageBubble.vue?vue&type=script&lang=js&"
export * from "./AgentMessageBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports